/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], function() {

	const constants = {};
	Object.defineProperty(constants, 'CAPABILITY_NAMES', {
		enumerable: true,
		writable: false,
		value: Object.freeze({
			CAN_GENERATE_CSV_OUTPUT: 'canGenerateCSVOutput',
			CAN_GENERATE_XML_OUTPUT: 'canGenerateXMLOutput',
			CAN_GENERATE_PDF_OUTPUT: 'canGeneratePDFOutput',
			CAN_GENERATE_XLS_OUTPUT: 'canGenerateXLSOutput'
		}),
		configurable: false
	});

	Object.defineProperty(constants, 'OUTPUT_FORMATS', {
		enumerable: true,
		writable: false,
		value: Object.freeze({
			HTML: 'HTML',
			CSV: 'CSV',
			XML: 'XML',
			PDF: 'PDF',
			SPREADSHEETML: 'spreadsheetML',
			XLSXDATA: 'xlsxData'
		}),
		configurable: false
	});

	return constants;
});